/* eslint-disable */

import React, { useState } from "react";

import { FileUpload } from "icons";

// import { Modal } from "clearsense-ui/components";
// import { Typography, Button, FileUploader } from "clearsense-ui/components";

const UploadModal = ({
  showModal,
  setShowModal,
  handleFileLoaded,
  handleFileUpload,
}) => {
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  return (
    <div></div>
    // <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
    //   <Modal.Header>
    //     <Typography style="h3">Upload Logo</Typography>
    //   </Modal.Header>
    //   <Modal.Body>
    //     <FileUploader
    //       onUploadFinish={handleFileLoaded}
    //       setIsButtonLoading={setIsButtonLoading}
    //     />
    //   </Modal.Body>
    //   <Modal.Footer className="space-x-2">
    //     <Button
    //       icon={() => <FileUpload />}
    //       label="Upload"
    //       onClick={handleFileUpload}
    //       size="large"
    //       loading={isButtonLoading}
    //     />
    //     <Button
    //       style="text"
    //       label="Cancel"
    //       onClick={() => setShowModal(false)}
    //       size="large"
    //     />
    //   </Modal.Footer>
    // </Modal>
  );
};

export default UploadModal;
